import React, { useEffect, useState } from 'react';

const ConversionValidationSummary = ({ groups }) => {
  const [open, setOpen] = useState(false);
  const issueCount = groups.reduce((total, group) => total + group.messages.length, 0);

  useEffect(() => {
    if (issueCount === 0) setOpen(false);
  }, [issueCount]);

  return (
    <div className="relative h-11">
      {issueCount === 0 ? (
        <div className="flex h-11 items-center rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm text-slate-600">
          <span className="mr-2 text-emerald-600" aria-hidden="true">✓</span>
          Sin pendientes de validación detectados
        </div>
      ) : (
        <>
          <button
            type="button"
            onClick={() => setOpen((current) => !current)}
            aria-expanded={open}
            className="flex h-11 w-full items-center justify-between rounded-lg border border-amber-200 bg-amber-50 px-3 text-left text-sm text-amber-950 hover:bg-amber-100"
          >
            <span className="font-semibold">
              {issueCount} {issueCount === 1 ? 'pendiente de validación' : 'pendientes de validación'}
            </span>
            <span className="text-xs font-semibold text-amber-800">
              {open ? 'Ocultar detalles' : 'Ver detalles'}
            </span>
          </button>

          {open && (
            <div className="absolute left-0 right-0 top-full z-30 mt-1 max-h-64 overflow-y-auto rounded-xl border border-amber-200 bg-white p-4 shadow-xl">
              <div className="space-y-3">
                {groups.map((group) => (
                  <div key={group.key}>
                    <div className="text-sm font-bold text-slate-900">{group.title}</div>
                    <ul className="mt-1 list-disc space-y-1 pl-5 text-sm text-slate-700">
                      {group.messages.map((message, index) => (
                        <li key={`${group.key}-${index}`}>{message}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ConversionValidationSummary;
